import { withTheme } from "@emotion/react";
import CITFormGroup from "../../../../Form/CITFormGroup";
import DateInput from "../../../../Form/DateInput";
import FileInput from "../../../../Form/FileInput";
import { Typography, Box, Stack } from "@mui/material";
import SelectInput from "../../../../Form/SelectInput";

const JobRequirements = (props) => {

    const inputdata = [

        { fileLable: 'Professional License/Certification', dateLable: 'Date completed', inputFileName: 'professional_license', inputDateName: 'professional_license_expiry_date' },
        { fileLable: 'Current Resume', dateLable: 'Expiration Date (Optional)', inputFileName: 'resume', inputDateName: 'resume_expiry_date' },
        { fileLable: 'Professional Liability Insurance (Contractor Only)', dateLable: 'Expiration Date ', inputFileName: 'liability_insurance', inputDateName: 'liability_insurance_expiry_date' },
        { fileLable: 'Driver’s License (to be verified by agency', dateLable: 'Expiration Date ', inputFileName: 'divers_license', inputDateName: 'divers_license_expiry_date' },
        { fileLable: '2nd Form of ID (e.g. US Passport, SSN Card) to be verified by agency', dateLable: 'Expiration Date ', inputFileName: 'government_id', inputDateName: 'government_id_expiry_date' },
        { fileLable: 'Car Insurance', dateLable: 'Expiration Date ', inputFileName: 'car_insurance', inputDateName: 'car_insurance_expiry_date' },
        { fileLable: 'Car Registration', dateLable: 'Expiration Date ', inputFileName: 'car_registration', inputDateName: 'car_registration_expiry_date' },
        { fileLable: 'CPR Card', dateLable: 'Expiration Date ', inputFileName: 'cpr_card', inputDateName: 'cpr_card_expiry_date' },
        { fileLable: 'Physical Exam Results (no older than 6 months from Hire Date)', dateLable: 'Date completed ', inputFileName: 'physical_exam_result', inputDateName: 'physical_exam_result_expiry_date' },
        { test_type: ['TB Test Quantiferon', 'TB Test Standard', 'TB Test XRAY'], fileLable: 'TB Test Results (no older than 6 months from Hire Date)', dateLable: 'Date completed', inputFileName: 'tb_test_result', inputDateName: 'tb_test_result_expiry_date' },
        { fileLable: 'Flu Shot Proof or Declination', dateLable: 'Date completed', inputFileName: 'flu_shot_result', inputDateName: 'flu_shot_result_expiry_date' },
        { fileLable: 'Hepatitis B Proof or Declination', dateLable: 'Date completed', inputFileName: 'hepatitis_b_result', inputDateName: 'hepatitis_b_expiry_date' },
        { fileLable: 'Covid Proof or Declination', dateLable: 'Date completed', inputFileName: 'covid_result', inputDateName: 'covid_result_expiry_date' },

    ]

    const theme = props.theme
    return (

        <Box width={'inherit'}>

            <Stack mx={{xs:'19px', sm:'60px',md:'85px'}} justifyContent={'space-around'} mt={'24px'} >
                <Typography mb={'24px'} mt={'48px'} sx={{...theme.typography.heading, fontSize:{xs:'18px',sm:'20px',md:'29px'}}} gutterBottom>
                    {'EMPLOYMENT APPLICATION AND CREDENTIALS/REQUIREMENTS'}
                </Typography>
                <Typography mb={'50px'} sx={theme.typography.body} gutterBottom>
                    {'Dear Applicant,'}
                </Typography>
                <Typography sx={theme.typography.body} gutterBottom>
                    {'Thank you for your interest in joining our team of skilled health care professionals and dedicated agency staff. We believe that empowering our clinicians will result in providing high quality patient-centered care in the communities we serve. Our vision is to become a leading home health agency with respect to standards and practices. Our team consists of compassionate individuals committed to helping our patients. The following documents are required along with your completed application.'}
                </Typography>
            </Stack>

            {
                inputdata.map((formData,i) => (
                    <CITFormGroup key={i}>
                        <FileInput   showImage title="Add File" fileLable={formData.fileLable} />
                        {formData.test_type && <SelectInput options = {formData.test_type}/>}
                        <DateInput dateLable={formData.dateLable} />
                    </CITFormGroup>
                ))
            }


        </Box>



    )
}

export default withTheme(JobRequirements);